<template>
		<div style="width:100%;height:100%;">
			<!-- 主文 -->
			<div style="display: flex;justify-content: center;align-items: center;">
				<div style="display: flex;margin-top: 50px;">
					<div style="border-right:1px solid #eeeeee;">
						<div v-for="(item,index) in detaila" :key="index" @click="tapone(index)">
							<div :class="index!=0?'bjtops':''" style="display:flex;align-items:center;position:relative;">
								<div class="bttrue" >{{item.a}}</div>
								<div v-if="index!=tabIndexs" class="quan"></div>
								<img v-else class="quans"  src="../assets/banner/5.png"/>
							</div>
						</div>
					</div>
					<div style="margin-left:30px;width:900px;margin-bottom:30px;">
						<div style="display: flex;flex-direction: column;">
							<div style="margin-left:20px;border:1px solid #EEEEEE;margin-top: 20px;width:795px;">
								<div style="width:795px;height:230px;margin-bottom:30px;">
									<div class="jbxx" style="font-weight:bold;">基本信息</div>
									<div class="xx bjtop" style="display: flex;">
										<div>
											公司名称<input  v-model="data.data" disabled="false" class="bjleft inputs" style="width:350px;margin-left:20px;background-color:#FAF7FA;"></input>
										</div>
										<!-- <div style="margin-left:20px;">
											手机号码<input  class="bjleft inputs" style="margin-left:20px;background-color:#FAF7FA;"></input>
										</div> -->
									</div>
									<div class="xx bjtop" style="display: flex;">
										<div>
											注册资金<input v-model="data.money" disabled="false" class="bjleft inputs" style="width:350px;margin-left:20px;background-color:#FAF7FA;"></input>
										</div>
										<!-- <div style="margin-left:20px;">
											姓名<input  class="bjleft inputs" style="margin-left:48px;background-color:#FAF7FA;"></input>
										</div> -->
									</div>
									<div class="xx bjtop" >公司规模<input v-model="data.scale" disabled="false" class="bjleft inputs" style="width:350px;margin-left:20px;background-color:#FAF7FA;"></input>
									</div>
									<div class="xx bjtop">公司资料<textarea v-model="data.title" disabled="false" class="bjleft inputs" type="text" style="width:345px;height:70px;margin-left:20px;resize : none;background-color:#FAF7FA;"></textarea>
									</div>
								</div>
							</div>
							<div style="margin-left:20px;border:1px solid #EEEEEE;margin-top:20px;width:795px;">
								<div style="width:795px;height: 300px;">
									<div class="jbxx" style="font-weight:bold;">需求介绍</div>
									<div class="xx bjtop" style="display:flex;align-items:center;">
											<div>采购地区</div>
											<div style="margin-left:10px;opacity:0.5;">
												<div>{{data.city}}</div>
											</div>
									</div>
									<div style="padding-left:30px;">
										<textarea disabled="false" v-model="name"  class="bjleft xx wbk" ></textarea>
									</div>
								</div>
							</div>
							<div style="margin-left:20px;border:1px solid #EEEEEE;margin-top: 20px;margin-bottom:30px;width:795px;">
								<div style="width:795px;height:150px;margin-bottom:30px;">
									<div class="jbxx" style="font-weight:bold;margin-bottom: 30px;">相关需求信息</div>
									<div style="text-align: left;margin-left:20px;display:flex;">
											<div class="buttonv" >{{data.p_name}}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			
		</div>
</template>

<script>
	import axios from '../util/http.js'
	import base from '../util/base.js'
	export default {
		name:"detailstwo",
		components:{
		},
		data() {
			return {
				url:'https://www.baidu.com/',
				dynamicTags: [],
				inputVisible: false,
				inputValue: '',
				tabIndex:7,
				tabIndexs:0,
				tabIndexc:0,
				data:'',
				name:'',
				detaila:[
					{a:'基本信息'},
					{a:'需求介绍'},
					{a:'相关需求信息'},
				],
			}
		},
		created() {
			this.data=this.$route.params.data
			this.name=this.data.content.replace(/<\/?.+?>/g,"")
			console.log(this.name,333);
			console.log(this.data,222);
		},
		methods: {
		tzxx:function(e){
			this.tabIndexs=e
		},
		tap:function(e){
			this.tabIndexc=e
			this.id=this.dynamicTags[e].id
		},
		 handleClose(tag) {
		        this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
		      },
		      showInput() {
		        this.inputVisible = true;
		        this.$nextTick(_ => {
		          this.$refs.saveTagInput.$refs.input.focus();
		        });
		      },
		      handleInputConfirm() {
		        let inputValue = this.inputValue;
		        if (inputValue) {
		          this.dynamicTags.push(inputValue);
		        }
		        this.inputVisible = false;
		        this.inputValue = '';
		      },
			  tapone(e){
				  this.tabIndexs=e;
				  if(e==1){
					  window.scrollTo(0, document.documentElement.scrollHeight-document.documentElement.clientHeight); 
				  }else if(e==2){
					  window.scrollTo(0, document.documentElement.scrollHeight-document.documentElement.clientHeight); 
				  }
			  },
			  }
	}
</script>

<style lang="scss" scoped>
	.bttrue{
		width:100px;
		text-align:right;
		padding-right:30px;
	}
	.bttrue:hover{
	cursor:pointer;
	}
	.wbk{
		background-color:#FAF7FA;
		width:500px;
		height:170px;
		margin-top:20px;
		padding-top:10px;
		padding-left:10px;
		resize : none;
		border: 0;  // 去除未选中状态边框
		outline: none; // 去除选中状态边框
	}
	.buttonv{
		font-size:14px;
		padding:5px 10px;
		background-color:#5BD5D0;
		margin-left:20px;
		color:white;
		text-align:center;
		line-height:40px;
		border-radius: 4px;
		box-sizing: border-box;
	}
	.element .style {
	    text-align: left;
	    margin-left: 20px;
	}
	.button-new-tag[data-v-41e2b943] {
	    margin-left: 10px;
	    height: 32px;
	    line-height: 30px;
	    padding-top: 1px;
	    padding-bottom: 0;
	}
	.zwk{
		margin:0px 10px 0px 0px;
		width: 348px;
		height:695px;
		background-color:#ffffff;
	}
	.botton-two{
		background-color:#169BD5;
		border-radius: 4px;
		color: white;
		width:100px;
		height: 30px;
		line-height:30px;
		font-size:12px;
		margin-left:720px;
		margin-bottom:30px;
	}
	.xx{
		text-align: left;
		display: flex;
		margin-left: 20px;
		font-size:14px;
	}
	.zwk2{
		width: 863px;
		height:695px;
		background-color:#ffffff;
	}
	.jbxx{
		background-color:#FAF7FA;
		height:53px;
		line-height:53px;
		text-align:left;
		padding-left:20px;
	}
	.bjtops{
		margin-top:20px;
	}
	.quan{
		background-color: #BCBCBC;
		width:9px;
		height:9px;
		border-radius:100px;
		position:absolute;
		right:-5px;
	}
	.inputs{
		 border: 0;  // 去除未选中状态边框
		 outline: none; // 去除选中状态边框
		 background-color: rgba(0, 0, 0, 0);// 透明背景
	}
	.quans{
		position:absolute;
		right:-10px;
		top:1px;
	}
	.color{
		color: #FFFFFF;
		width:135px;
		height:42px;
		line-height: 42px;
		text-align: center ;
	}
	.serch{
		color:#FFFFFF;
		font-size:10px;
		background-color:#20919D;
		text-align:center;
		height: 31px;
		line-height:31px;
		width:50px;
	}
	.flex{
		display:flex;
	}
	.flexjust{
		justify-content: center;
	}
	.flexali{
		align-items: center;
	}
	.colorwhite{
		color: #FFFFFF;
	}
	.dhl{
		color:#FFFFFF;
		font-size:15px;
		justify-content: center;
		align-items: center;
		padding:0 20px;
	}
	.dhls{
		color:#FFFFFF;
		font-size:15px;
		background-color: #59D4CF;
		display:flex;
		justify-content: center;
		align-items: center;
		padding:0 20px;
	}
	.Line{
		width:1px;
		height: 14px;
		background-color:#FFFFFF;
	}
	.font{
		font-size:14px;
	}
	.por{
		display:flex;
		flex-direction: column;
		margin-left:10px;
	}
	.bodya{
		background-color:#5AD6CE;
		width:100px;
		height:86.9px;
		flex-direction: column;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #FFFFFF;
	}
	.iur{
		margin-left: 5px;
	}
	.bjtop{
		margin-top: 10px;
	}
	.bjleft{
		margin-left:10px;
	}
	.bjright{
		margin-right:10px;
	}
	.bjbottom{
		margin-bottom:10px;
	}
	.zxls{
		text-align: left;
		color:#181818;
		font-size:16px;
	}
	.el-tag + .el-tag {
	    margin-left: 10px;
	  }
	  .button-new-tag {
	    margin-left: 10px;
	    height: 32px;
	    line-height: 30px;
	    padding-top: 0;
	    padding-bottom: 0;
	  }
	  .input-new-tag {
	    width: 90px;
	    margin-left: 10px;
	    vertical-align: bottom;
	  }
	  .router-link-active {
	    text-decoration: none;
	  }
	  a {
	    text-decoration: none;
	  }
</style>
